module.exports = __webpack_public_path__ + "img/196.a45551f2.jpg";